import React from "react";
import EditCar from "../conponents/car/EditCar/EditCar.jsx";

export const EditCarPage = () => <EditCar />
